//src//shared/components/LoadingScreen.tsx
import React from "react";
import { PuffLoader } from "react-spinners";
import "./Loading.css";

interface LoadingScreenProps {
  size?: number;
  color?: string;
}

function LoadingScreen({ size = 100, color = "#EAEFDC" }: LoadingScreenProps) {
  return (
    <div className='modal1'>
      <div className='overlay1'></div>
      <div className='modal-content1'>
        <PuffLoader id='Spinner' color={color} cssOverride={{}} size={size} speedMultiplier={1} />
      </div>
    </div>
  );
}

export default LoadingScreen;
